import script from "./TressCheckboxList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TressCheckboxList.vue?vue&type=script&setup=true&lang=ts"

import "./TressCheckboxList.vue?vue&type=style&index=0&id=1b22de14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b22de14"]])

export default __exports__